import './_range-slider.scss';

import RangeSlider from './RangeSlider';

export default RangeSlider;
